import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const CloseDialogButtonWidget: WidgetRegistryEntry = {
  name: "CloseDialogButton",
  configuration: () => import("./configuration").then((m) => m.CloseDialogButtonConfiguration),
  component: () => import("./close-dialog-button-widget.component").then((m) => m.CloseDialogButtonWidgetComponent)
};
